import { schema } from "normalizr";

export const FlightArrangementItinerarySchema: schema.Entity =
  new schema.Entity("flightArrangementItinerary", {});
